/**
 * Adds the key-value `pair` to `map`.
 *
 * @private
 * @param {Object} map The map to modify.
 * @param {Array} pair The key-value pair to add.
 * @returns {Object} Returns `map`.
 */
function addMapEntry(map, pair) {
  // Don't return `map.set` because it's not chainable in IE 11.
  map.set(pair[0], pair[1]);
  return map;
}

export default addMapEntry;



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/_addMapEntry.js
// module id = 1161
// module chunks = 0